<template>
  <div>
    <b-carousel id="post_poll" :interval="10000" :controls="recentPolls.length > 1 ? true : false" dark>
      <b-carousel-slide v-for="(poll, index) in recentPolls" :key="index">
        <b-card
          tag="article"
          class="mb-2 border-0"
          :id="`poll-card-${poll.hashid}`"
          v-observe-visibility="{
            callback: (isVisible, entry) =>
              visibilityChanged(isVisible, entry, poll),
            once: true,
            throttle: 0,
            throttleOptions: {
              leading: 'visible',
            },
            intersection: {
              threshold: 0,
            },
          }"
        >
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div class="d-flex align-items-center">
              <!-- avatar -->
              <b-avatar :src="poll.user.avatar" size="36" class="mr-1" />
              <!--/ avatar -->
              <div class="profile-user-info">
                <h6 class="mb-0">
                  {{ poll.user.name }}
                </h6>
                <small class="text-muted">
                  <!-- {{ data.user.designation }} -->
                </small>
              </div>
            </div>
            <div class="status-update">
              <span class="anonymous-user cursor-pointer">
                <b-img :src="require('@/assets/images/icons/guest-user.svg')" size="85" class="mr-1" v-b-tooltip.hover.v-default title="Anonymous Poll" v-if="poll.voter_identity_type != 'identified'" />
              </span>
              <b-img  v-b-modal="'poll-modal-lg-' + poll.hashid" :src="require('@/assets/images/icons/eventpoll/poll-status.svg')" size="26" v-b-tooltip.hover.v-default title="View Status"  v-if="poll.voter_identity_type == 'identified'"/>
              <!-- <b-img @click="viewStats(index)" :src="require('@/assets/images/icons/eventpoll/poll-status.svg')" size="26" v-b-tooltip.hover.v-default title="View Status"/> -->
            </div>
          </div>
          <b-card-text class="mb-0">
            <h4 class="text-default">{{ poll.title }}</h4>
          </b-card-text>
          <!-- <vue-poll v-bind="poll.poll_data" @addvote="addVote"/> -->
          <!-- <b-card-text v-html="poll.description">
        </b-card-text> -->
          <div v-if="!poll.expired && !poll.showResults" class="poll-description">
            <h3 class="qst">{{ poll.description }}</h3>
            <div v-if="poll.allow_multiple == 'true'">
              <b-form-checkbox
                v-for="(option, k) in poll.options"
                :key="k"
                :name="index + 'pollCheckbox' + k"
                :value="option.hashid"
                class="custom-control-primary mt-1"
                v-model="poll.userChoise"
              >
                {{ option.option_title }}
              </b-form-checkbox>
            </div>
            <div v-else>
              <b-form-radio
                v-for="(option, k) in poll.options"
                :key="k"
                :name="index + 'pollCheckbox' + k"
                :value="option.hashid"
                v-model="poll.userChoise"
                class="custom-control-primary mt-1"
              >
                {{ option.option_title }}
              </b-form-radio>
            </div>

            <b-row class="mt-1 align-items-center mx-25">
              <!--Anonymous Vote -->
              <!-- <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-secondary"
                  @click="addVote(poll)"
                  pill
                  class="w-100 vote-btn"
                >
                Anonymous Vote
                </b-button> -->
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-secondary"
                  @click="addVote(poll)"
                  pill
                  :class="(poll.userChoise && poll.userChoise.length)?'w-100 vote-btn active':'w-100 vote-btn'"
                >
                Vote
                </b-button>



              <!-- <b-col md="7" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="addVote(poll)"
                >
                  Vote
                </b-button>
                <b-button
                  class="ml-1"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="viewStats(index)"
                >
                  View Stats
                </b-button>
                <b-button
                  class="ml-1"
                  v-if="poll.voter_identity_type == 'identified'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="info"
                  v-b-modal="'modal-lg-' + poll.hashid"
                >
                  View Voters
                </b-button>
              </b-col> -->
              <!--Voting-->
              <!-- <b-col md="5" class="mt-1" v-if="poll.limited_time == 'true'">
                <b-badge variant="light-primary poll-timer">
                  <p class="mb-1">Voting Ends in :</p>
                  <Countdown :deadline="poll.expires_in"></Countdown>
                </b-badge>
              </b-col> -->
            </b-row>
            <!-- <b-badge variant="light-primary" class="mt-1 mb-1">
              Poll Status : In Progress
            </b-badge>
            <b-badge
              v-if="poll.voter_identity_type == 'identified'"
              variant="info"
              class="badge-glow ml-1"
            >
              Identified Vote
            </b-badge>
            <b-badge
              v-else
              variant="danger"
              class="badge-glow ml-0 ml-lg-1 mt-2"
            >
              Anonymous Vote
            </b-badge> -->
          </div>
          <div class="poll-description" v-else>
            <vue-poll v-bind="poll.poll_data"/>
            <b-button
              class="w-100 vote-btn"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              @click="closeStats(index)"
              v-if="!poll.expired"
              pill
            >
              Cancel Vote
            </b-button>
            <!-- <b-row class="mt-1">
              <b-col>
                <b-badge variant="light-success" v-if="!poll.expired">
                  In Progress
                </b-badge>
                <b-badge variant="light-success" v-else>
                  Completed
                </b-badge>
                <b-badge
                  v-if="poll.voter_identity_type == 'identified'"
                  variant="info"
                  class="badge-glow ml-1"
                >
                  Identified Vote
                </b-badge>
                <b-badge
                  v-else
                  variant="danger"
                  class="badge-glow ml-0 ml-lg-1 mt-2"
                >
                  Anonymous Vote
                </b-badge>
              </b-col>
            </b-row> -->
          </div>
        </b-card>
        <b-modal
          :id="'poll-modal-lg-' + poll.hashid"
          hide-footer
          centered
          size="lg"
        >
        <template #modal-header="{ close }">
          <h5 class="mb-0 font-weight-bolder">{{poll.title}}</h5>
          <div class="d-flex align-items-center">
          <div class="status-process">
            <b-badge variant="light-warning" v-if="!poll.expired">
              In Progress
            </b-badge>
            <b-badge variant="light-success" v-else>
              Completed
            </b-badge>
          </div>
            <b-button size="sm" variant="outline-transparent" class="p-0" @click="close()">
              <feather-icon icon="XIcon" size="24" class="text-body align-middle ml-2"/>
            </b-button>
          </div>
        </template>
          <b-card-text class="poll-descr">
            {{ poll.description }}
          </b-card-text>
          <app-collapse accordion class="poll-popup">
            <app-collapse-item
              v-for="(option, k) in poll.options"
              :key="k"
              :title="calcPercentage(poll,option.option_title)  + ' : ' + option.option_title"
              :class="option.is_highest ?'highest-vote mb-1': 'mb-1'"
            >
              <b-avatar-group size="32px">
                <b-avatar
                  v-for="(voter, k) in option.voters"
                  v-b-tooltip.hover
                  class="pull-up"
                  :title="voter.name"
                  :src="voter.avatar"
                />
              </b-avatar-group>
            </app-collapse-item>
          </app-collapse>
        </b-modal>
      </b-carousel-slide>
      </b-carousel>
      <b-col v-if="busy">
        <div
          class="text-center mb-2 d-flex align-items-center justify-content-center"
        >
          <div :show="busy" class="d-flex align-items-center">
            <b-spinner
              variant="primary"
              class="m-1"
              label="Spinning"
            ></b-spinner>
          </div>
        </div>
      </b-col>
      <b-col v-else class="p-0">

        <div
          v-if="recentPolls.length == 0"
          class="text-center my-50 empty-data skeleton-loader"
        >
          <div v-if="isBusy" class="text-center empty-data">
            <!-- <b-img :src="require('@/assets/images/empty-data/zircly-loader.gif')" width="100" class="mr-50" style="background-color: transparent" /> -->
            <!-- <div class="text-center mb-2 d-flex align-items-center justify-content-center">
              <div :show="busy" class="d-flex align-items-center">
                <b-spinner
                  variant="outline-primary"
                  class=""
                  label="Spinning"
                ></b-spinner>
              </div>
            </div>
            <h4> Loading </h4>
            <p class="d-block mb-1">Please Wait</p> -->
            <div class="d-flex justify-content-between align-items-center mb-2 post-header w-100">
                    <div class="d-flex align-items-center w-100">
                      <!-- avatar -->
                      <b-skeleton type="avatar" size="40" class="mr-50"></b-skeleton>
                      <!--/ avatar -->
                      <div class="w-100 gap-10 d-flex flex-column">
                        <h6 class="mb-0">                      
                          <b-skeleton  width="80%" class="mb-0"></b-skeleton>
                        </h6>
                        <small>
                          <b-skeleton  width="80%" class="mb-0"></b-skeleton>
                        </small>
                      </div>
                    </div>
                    <div class="d-flex w-100 align-items-center justify-content-end">
                      <b-skeleton  width="30%"></b-skeleton>
                    </div>
                  </div>
                  <div class="body-content">
                    <b-skeleton width="100%" class="my-1"></b-skeleton>
                    <b-skeleton width="100%" class="my-1"></b-skeleton>
                    <div class="descriptiom">
                      <ul class="m-0 p-0 list-unstyled">
                        <li class="d-flex align-items-center my-1">
                          <b-skeleton type="avatar" size="16" class="mr-50 checkbox"></b-skeleton>
                          <b-skeleton width="100%" class="mb-0"></b-skeleton>
                        </li>
                        <li class="d-flex align-items-center my-1">
                          <b-skeleton type="avatar" size="16" class="mr-50 checkbox"></b-skeleton>
                          <b-skeleton width="100%" class="mb-0"></b-skeleton>
                        </li>
                        <li class="d-flex align-items-center my-1">
                          <b-skeleton type="avatar" size="16" class="mr-50 checkbox"></b-skeleton>
                          <b-skeleton width="100%" class="mb-0"></b-skeleton>
                        </li>
                      </ul>
                    </div>
                    <b-skeleton type="input" class="my-2"></b-skeleton>
                  </div>
          </div>
          <div v-else class="mt-2 mb-25">
            <b-img :src="require('@/assets/images/icons/eventpoll/empty-poll.svg')" size="85" class="mb-2" />
            <b-img :src="require('@/assets/images/icons/eventpoll/dark-poll.svg')" size="85" class="mb-2 dark-eventimg d-none" />
            <h4> No Polls at the Moment! </h4>
            <b-button class="blog-btn-block secndary-primarybtn m-auto" variant="outline-secondary" v-b-modal.add-poll-sidebar pill>
              <span class="text-nowrap">Create Poll</span>
            </b-button>
          </div>
        </div>
      </b-col>
    </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  VBTooltip,
  BFormTextarea,
  BFormRadio,
  BAvatarGroup,
  BAvatar,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onMounted, ref, watch } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import VueTimepicker from "vue2-timepicker/src";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import BCardActionsContainer from "@core/components/b-card-actions/BCardActionsContainer.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

// file-pond dependencies
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import moment from "moment";
import useJwt from "@/auth/jwt/useJwt";
import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import QuillInput from "@/components/QuillInput.vue";
import PollEdit from "@/views/feed/polls/PollEdit.vue";
import VuePoll from "@/components/Poll.vue";
import Countdown from "@/views/feed/polls/CountDown.vue";
import { bus } from "@/main.js";

import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

import $ from "jquery";
import JQ from "jquery";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageValidateSize,
  FilePondPluginFileValidateSize,
  FilePondPluginFileEncode
);

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,

    vSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    flatPickr,
    VueTimepicker,
    FilePond,
    QuillInput,
    BCardActions,
    BCardActionsContainer,
    PollEdit,
    BFormRadio,
    VuePoll,
    Countdown,
    AppCollapse,
    AppCollapseItem,
    BAvatarGroup,
    BAvatar,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
    infiniteScroll,
  },
  model: {
    prop: "sidebarPollAddActive",
    event: "update:sidebarPollAddActive",
  },
  props: {
    recentPolls:{
      type:Array,
    }
  },
  data() {
    return {
      isBusy: true,
      userData: this.$cookies.get("userData"),
      zoom_access: this.checksAccessToken(),
      sidebarPollEditActive: false,
      pollId: "",
      data_local: {
        name: "",
        location: "",
        start_date_n_time: moment().format("YYYY-MM-DD ") + "09:00",
        end_date_n_time: moment().format("YYYY-MM-DD ") + "09:00",
        description: "",
        video_conferencing: "meet",
        password: "",
        attachments: [],
        poster: "",
      },
      customFields: [],
      support_categories: [],
      priority_option: [],
      status_option: [],
      myFiles: [],
      channel_types: [],
      channel_type_select: [],
      poster: "",
      ip: null,
      searchQuery: "",
      busy: false,
      lastPage: 1,
      nextPage: 1,
      currentPage: 1,
    };
  },
  computed: {},
  setup(data_local, myFiles) {
    const USER_APP_STORE_MODULE_NAME = "app-posts";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      // store.registerModule(USER_APP_STORE_MODULE_NAME, postStoreModule);

      // UnRegister on leave
      onUnmounted(() => {
        if (store.hasModule(USER_APP_STORE_MODULE_NAME))
          store.unregisterModule(USER_APP_STORE_MODULE_NAME);
      });

    const { refFormObserver, getValidationState, resetForm } = formValidation();

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
  
  watch: {
    recentPolls(val){
      if(val.length >= 0){
        this.isBusy = false;
      }
    },
    sidebarPollAddActive(val) {
      this.data_local = {
        name: "",
        location: "",
        start_date_n_time: moment().format("YYYY-MM-DD ") + "09:00",
        end_date_n_time: moment().format("YYYY-MM-DD ") + "09:00",
        description: "",
        video_conferencing: "meet",
        password: "",
        attachments: [],
      };
      this.$refs.add_poll_sidebar.show();
      this.generate();
      this.myFiles = [];
      if (this.itemId) {
        this.data_local = this.itemData;
      }
    },
    searchQuery(val) {
      if (val.length > 3 || val.length == 0) {
        this.getPolls();
      }
    },
  },
  methods: {
    calcPercentage(poll,option_title){
      if (poll.poll_data.totalVotes === 0)
          return '0%';                
      
      //Calculate percent

      for (let index = 0; index < poll.poll_data.answers.length; index++) {
        const a = poll.poll_data.answers[index];
        if(a.text == option_title){
          if (!isNaN(a.votes) && a.votes > 0)
            return ( Math.round( (parseInt(a.votes)/poll.poll_data.totalVotes ) * 100) ) + '%'
          else
            return'0%';
        }
        
      }
      return'0%';

  },
    visibilityChanged(isVisible, entry, customArgument) {
      if (isVisible) {
        this.isVisible = isVisible;
        // console.log(Math.round(entry.intersectionRatio * 100) + '%')
        // console.log(entry.target.id);
        // console.log(isVisible);
        // console.log(entry.target.id);
        // console.log(customArgument.hashid);
        this.getPollData(customArgument.hashid);
      }
    },
    getPollData(itemId) {
      if (!itemId) {
        console.log("no itemId");
        return true;
      }
      const self = this;
      let data = {};
      data.url = "/polls/" + itemId;
      self.isBusy = true;
      self.$store
        .dispatch("app/get", data)
        .then((res) => {
          self.event_data = res.data.data;
          self.isBusy = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPolls() {
      const self = this;

      let data = {};
      data.url = "/polls";
      data.params = { q: self.searchQuery, createdBy: this.$route.params.id ,perPage:3};
      // this.busy = true;
      self.$store
        .dispatch("app/get", data)
        .then((res) => {
          this.recentPolls = res.data.data;
          self.busy = false;
          this.nextPage = res.data.meta.current_page + 1;
          this.lastPage = res.data.meta.last_page;
          this.currentPage = res.data.meta.current_page;
        })
        .catch((error) => {
          console.log(error);
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Polls list Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });

          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Oops! Polls list Failed`,
                icon:'BellIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
        });
    },
    generate(characters = "a-z,A-Z,0-9", length = 10) {
      let charactersArray = characters.split(",");
      let CharacterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        CharacterSet += "![]{}()%&*$#^<>~@|";
      }

      for (let i = 0; i < length; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.data_local.password = password;
    },
    confirmDeleteRecord(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete Poll ${data.title}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary rounded-pill",
          cancelButton: "btn btn-outline-danger rounded-pill ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRecord(data.hashid);
        }
      });
    },
    deleteRecord(id) {
      const self = this;
      let data = {};
      data.url = "polls/" + id;
      this.$store
        .dispatch("app/delete", data)
        .then((res) => {
          if (res.status == "204") {
            document.getElementById("poll-card-" + id).remove();
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Poll Deleted",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: "Poll Deleted Successfully.",
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Poll Deleted',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Poll Deleted Successfully.',
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Poll Deletion failed.",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Poll Deletion failed.',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
          // self.refetchData();
        })
        .catch((err) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Poll Deletion failed.1",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Poll Deletion failed.`,
                icon:'BellIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
          console.error(err);
        });
    },

    setEndDate(e) {
      if (this.data_local.end_date_n_time == "") {
        this.data_local.end_date_n_time = e;
      }
    },
    checksAccessToken() {
      if (this.$cookies.get("userData").zoom_linked === false) {
        return false;
      }
      return true;
    },
    openWindow(link) {
      window.open(link);
    },
    viewStats(pollIndex) {
      this.recentPolls[pollIndex].showResults = true;
    },
    closeStats(pollIndex) {
      this.recentPolls[pollIndex].showResults = false;
    },
    addVote(poll, index) {
      // console.log('You voted ' + poll.selectedOption + '! for poll '+poll.hashid);
      if (poll.allow_multiple == "true") {
        poll.selectedOptions = poll.userChoise.join();
      } else {
        poll.selectedOptions = poll.userChoise;
      }
      const self = this;
      let ip;
      JQ.ajax({
        dataType: "json",
        url: "http://ip-api.com/json",
        async: false,
        success: function (data) {
          ip = data.query;
        },
      });
      let data = {};
      data.url = "/poll/vote";
      data.params = {
        poll: poll.hashid,
        option: poll.selectedOptions,
        voter_ip: ip,
      };

      self.$store
        .dispatch("app/store", data)
        .then((res) => {
          console.log(res.status);
          this.getPolls();
        })
        .catch((error) => {
          console.log(error);
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Unablt to Cast Your Vote",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Oops! Unablt to Cast Your Vote`,
                icon:'BellIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
        });
    },
  },
};
</script>

<style lang="scss">
@import "~filepond/dist/filepond.min.css";
@import "~filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.vue__time-picker {
  width: 6em !important;
}
.vue__time-picker input.display-time {
  width: 100% !important;
  background: whitesmoke;
  height: 38px;
  border-radius: 5px;
  margin-left: 3px;
  color: grey;
}
.vue__time-picker .dropdown,
.vue__time-picker-dropdown {
  height: 14rem !important;
}
.vue__time-picker .dropdown .select-list,
.vue__time-picker-dropdown .select-list {
  height: 14rem !important;
}
select#year,
select#month,
select#day {
  padding: 5px 10px;
  background: #eaeaea;
  border: solid rgb(218, 218, 218) 0.5px;
  border-radius: 5px;
  margin-left: 5px;
}
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.filepond--credits {
  display: none;
}
.flatpickr-input {
  background: whitesmoke !important;
}
.modal-header {
  align-items: center;
}
</style>
